import { QuestionAnswerMap } from '@care-portals/api-interfaces';
import { LDNQuestionFieldAnswers } from '../initial/questions';

const DoseableLdnQuestions = [
  {
    label: 'What is your:',
    field: 'd_ldn_weightAndHeight2025',
    type: 'info',
    required: false,
    answer: {
      type: 'bmi',
      showLabel: true,
      bmiLabel: 'Your BMI is',
      heightLabel: 'What is your height in feet and inches?',
      weightLabel: 'What is your weight in pounds?'
    }
  },

  {
    label:
      'This visit type is specifically for the use of low-dose naltrexone (LDN) in the treatment of chronic pain and other chronic inflammatory conditions that have been previously evaluated by a healthcare provider. LDN may also provide benefits for appetite regulation in some individuals although LDN in general is not FDA-approved.',
    field: 'd_ldn_dosable_acknowledgment',
    type: 'select',
    answer: {
      type: 'single_select',
      options: [
        {
          value: 'I understand and would like to proceed',
          key: 'consent'
        },
        {
          value: 'I do NOT wish to continue',
          key: 'non_consent',
          class: 'option-decline'
        }
      ]
    }
  },
  {
    label: 'Please describe your primary symptoms (select all that apply).',
    field: 'd_ldn_primarySymptoms',
    type: 'select',
    answer: {
      type: 'multi_select',
      options: [
        { value: 'Joint pain', key: 'joint_pain' },
        { value: 'Muscle aches', key: 'muscle_aches' },
        { value: 'Digestive issues', key: 'digestive_issues' },
        { value: 'Brain fog', key: 'brain_fog' },
        { value: 'General fatigue', key: 'general_fatigue' },
        { value: 'Weight management/over eating', key: 'overeating' },
        { value: 'Other', key: 'other' }
      ]
    }
  },
  {
    label: 'Please provide more information about your symptoms',
    field: 'd_ldn_primarySymptomsOther',
    type: 'info',
    answer: {
      type: 'text',
      rows: 4,
      name: 'd_ldn_primarySymptomsOther'
    }
  },

  {
    label:
      'Are you aware of any triggers or known causes of your symptoms or inflammation? (select all that apply)',
    field: 'd_ldn_triggers',
    type: 'select',
    answer: {
      type: 'multi_select',
      options: [
        { value: 'Autoimmune disease', key: 'autoimmune' },
        { value: 'Chronic infection', key: 'chronic_infection' },
        { value: 'Allergy', key: 'allergy' },
        { value: 'Dietary factors', key: 'dietary' },
        { value: 'Environmental exposures', key: 'environmental' },
        { value: 'Other', key: 'other' },
        {
          value: 'I don’t know of any triggers',
          key: 'dont_know',
          uncheckOthers: true
        }
      ]
    }
  },
  {
    label: 'Please provide more information about your triggers',
    field: 'd_ldn_triggersOther',
    type: 'info',
    answer: {
      type: 'text',
      rows: 3,
      name: 'd_ldn_triggersOther'
    }
  },
  {
    label:
      'What treatments (medications, supplements, therapies) have you tried for this condition, and what were the results?',
    field: 'd_ldn_priorTreatments',
    type: 'info',
    answer: {
      type: 'text',
      field: 'd_ldn_priorTreatments'
    }
  },

  {
    label: `Consent:
Purpose of LDN Therapy:
Low Dose Naltrexone (LDN) is prescribed off-label for certain inflammatory conditions or appetite suppression. It may help modulate the immune system and reduce inflammation. LDN is approved by the FDA at higher doses for opioid and alcohol dependence, but use at low doses for inflammation is considered off-label.
Expected Benefits and Risks:
Potential Benefits: May include reduction in inflammation, decrease in pain, improvement in energy levels, and overall better quality of life. This may help reduce overall cravings. 
Possible Side Effects: Sleep disturbances, vivid dreams, mild headaches, gastrointestinal upset, and potential temporary changes in mood.
Long-Term Risks: Not fully established; studies are ongoing. Known risks at low doses are generally mild, but there is limited long-term data.
Off-Label Use:
I understand that LDN is not FDA-approved for treating inflammation or weight management alone. 
Contraindications and Precautions:
I have disclosed all current medications and medical conditions. I understand that LDN may not be safe if I am taking opioids, if I have certain medical conditions, or if I become pregnant.
Follow-Up and Monitoring:
I agree to follow the treatment plan and attend follow-up appointments as recommended by my healthcare provider. I will report any new symptoms or side effects promptly.
Voluntary Participation:
I understand that I may choose to discontinue LDN therapy at any time. My decision to participate is voluntary and based on a full understanding of the potential benefits and risks.
I verify that I am the patient and that I have answered the questions asked in this intake form. I confirm that I have reviewed and understood all the questions asked of me. I attest that the answers and information I have provided in this questionnaire is true and complete to the best of my knowledge. I understand that it is critical to my health to share complete health information with my doctor. I will not hold the doctor or affiliated medical practice responsible for any oversights or omissions, whether intentional or not, in the information that I provided.

By selecting below, you confirm that you:
- Have read and understood the information provided
- Understand the potential risks and benefits of using low dose naltrexone, as well as its off-label nature
- Agree to adhere to the monitoring plan and report any concerns or side effects to your healthcare provider`,
    field: 'd_ldn_consent',
    type: 'select',
    answer: {
      type: 'single_select',
      options: [
        {
          value:
            'I have read the consent and understand the content, I wish to proceed',
          key: 'consent'
        },
        {
          value: 'I have read the consent and I do NOT wish to move forward',
          key: 'non_consent',
          class: 'option-decline'
        }
      ]
    }
  }
] as const;

export type DosableLDNQuestionFieldAnswers = LDNQuestionFieldAnswers &
  Partial<QuestionAnswerMap<typeof DoseableLdnQuestions>>;
export default DoseableLdnQuestions;
